var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 4,
    viewBox: "0 0 8 4",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.775712 0.175736C1.01003 -0.0585786 1.38993 -0.0585786 1.62424 0.175736L4 2.55149L6.37573 0.175738C6.61005 -0.0585777 6.98995 -0.0585793 7.22426 0.175734C7.45858 0.410048 7.45858 0.789947 7.22427 1.02426L4.42427 3.82429C4.31174 3.93681 4.15913 4.00002 4 4.00002C3.84087 4.00002 3.68826 3.93681 3.57574 3.82429L0.775712 1.02426C0.541397 0.78995 0.541397 0.410051 0.775712 0.175736Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.1c9cb6642f3a00d37edee1d0cf2d912c.svg";
export { ForwardRef as ReactComponent };